import React, { useState, useEffect } from 'react'
import { Modal, Table, Tooltip } from 'antd'
import moment from 'moment'
import { queryCustomerFollows } from '@/services/customer'

export default function FollowInfoDialog(props) {
  const { dispatch, renderBtn = <>null btn</>, customerId } = props
  const [visible, setVisible] = useState(false)
  const [followInfo, setFollowInfo] = useState([])

  const columns = [
    {
      dataIndex: 'typeName',
      title: '工作类别',
    },
    {
      dataIndex: 'content',
      title: '随访情况',
      ellipsis: true,
      render(text) {
        return <Tooltip title={text}>{text}</Tooltip>
      }
    },
    {
      dataIndex: 'comment',
      title: '备注',
    },
    {
      dataIndex: 'createdAt',
      title: '创建时间',
      align: 'center',
      render(text) {
        return text ? moment(text).format('YYYY-MM-DD HH:mm') : ''
      }
    }
  ]

  const getFollowInfo = () => {
    queryCustomerFollows({ customerId })
      .then(({ data }) => {
        setFollowInfo(data)
      })
  }

  // modal的显示与隐藏
  const showModal = () => {
    setVisible(true)
    getFollowInfo()
  }
  const hideModal = () => setVisible(false)

  return (
    <>
      {React.cloneElement(renderBtn, { ...renderBtn.props, onClick: showModal })}
      <Modal
        title='跟进信息'
        visible={visible}
        onCancel={hideModal}
        width={800}
      >
        <Table
          columns={columns}
          dataSource={followInfo}
          pagination={false}
          size="small"
          rowKey="id"
        />
      </Modal>
    </>
  )
} 